import { PositionType, } from "@annunciate/core";
import { getFormattedProgressAndRemainingTime } from "./getFormattedProgressAndRemainingTime";
export const getBookmarkInfo = (bookmark, content) => {
    let title = "";
    let progress = "";
    if (!bookmark.position)
        return { title: "", progress: "" };
    if (bookmark.position.type === PositionType.TIME) {
        const positionTime = bookmark.position;
        const { timeProgressed } = positionTime && bookmark.duration
            ? getFormattedProgressAndRemainingTime(positionTime.value, bookmark.duration.length)
            : { timeProgressed: "" };
        progress = timeProgressed;
        if (content?.chapters) {
            for (const chapter of content.chapters) {
                if (chapter.location < positionTime.value) {
                    title = chapter.name;
                }
                else {
                    break;
                }
            }
        }
    }
    else if (bookmark.position.type === PositionType.EBOOK) {
        const positionEbook = bookmark.position;
        title = positionEbook.location.title || "";
        const totalProgression = positionEbook?.location?.locations?.totalProgression;
        progress = totalProgression !== undefined ?
            Math.round(totalProgression * 100) + "%" : "";
    }
    return { title, progress };
};
//# sourceMappingURL=getBookmarkInfo.js.map